

// import React, { useState } from 'react';
// import { Tabs, Tab, Box } from '@mui/material';
// import { AiOutlineFile } from 'react-icons/ai';      // Booking Summary icon
// import { MdLocationOn } from 'react-icons/md';       // Track Location icon
// import { FaCar } from 'react-icons/fa';              // Vehicle DOC icon
// import BookingSummary from './BookingSummary';
// import TrackLocation from './TrackLocation';
// import VehicalDoc from './VehicleDOC';

// const RideDetails = () => {
//     const [value, setValue] = useState(0); // State to track the selected tab

//     const handleChange = (event, newValue) => {
//         setValue(newValue);
//     };

//     return (
//         <div className="flex justify-center items-center min-h-screen bg-gray-100 w-full">
//             <div className="w-full bg-white rounded-lg shadow-md p-6">
//                 {/* Header with "My Ride" */}
//                 <div className="text-[#FF9630] font-semibold text-lg mb-4 text-left">My Ride</div>

//                 {/* Tabs Section */}
//                 <Box sx={{ width: '100%' }}>
//                     <Tabs 
//                         value={value} 
//                         onChange={handleChange} 
//                         aria-label="ride details tabs"
//                         TabIndicatorProps={{
//                             style: { display: 'none' } // Hide the default tab indicator
//                         }}
//                     >
//                         <Tab 
//                             label={
//                                 <div style={{ display: 'flex', alignItems: 'center' }}>
//                                     <AiOutlineFile size={20} style={{ marginRight: 8 }} />
//                                     Booking Summary
//                                 </div>
//                             }
//                             sx={{
//                                 backgroundColor: value === 0 ? '#FF9630' : 'transparent',
//                                 color: value === 0 ? '#fff' : '#2c2c2c',
//                                 border: value !== 0 ? '1px solid #d0d0d0' : 'none',
//                                 borderRadius: '8px',
//                                 minWidth: '150px',
//                                 textTransform: 'none',
//                                 fontWeight: 'bold',
//                                 mr: 1,
//                                 '&:hover': {
//                                     backgroundColor: value === 0 ? '#FF9630' : '#f5f5f5',
//                                 },
//                             }}
//                         />
//                         <Tab 
//                             label={
//                                 <div style={{ display: 'flex', alignItems: 'center' }}>
//                                     <MdLocationOn size={20} style={{ marginRight: 8 }} />
//                                     Track Location
//                                 </div>
//                             }
//                             sx={{
//                                 backgroundColor: value === 1 ? '#FF9630' : 'transparent',
//                                 color: value === 1 ? '#fff' : '#2c2c2c',
//                                 border: value !== 1 ? '1px solid #d0d0d0' : 'none',
//                                 borderRadius: '8px',
//                                 minWidth: '150px',
//                                 textTransform: 'none',
//                                 fontWeight: 'bold',
//                                 mr: 1,
//                                 '&:hover': {
//                                     backgroundColor: value === 1 ? '##FF9630' : '#f5f5f5',
//                                 },
//                             }}
//                         />
//                         <Tab 
//                             label={
//                                 <div style={{ display: 'flex', alignItems: 'center' }}>
//                                     <FaCar size={20} style={{ marginRight: 8 }} />
//                                     Vehicle DOC
//                                 </div>
//                             }
//                             sx={{
//                                 backgroundColor: value === 2 ? '#FF9630' : 'transparent',
//                                 color: value === 2 ? '#fff' : '#2c2c2c',
//                                 border: value !== 2 ? '1px solid #d0d0d0' : 'none',
//                                 borderRadius: '8px',
//                                 minWidth: '150px',
//                                 textTransform: 'none',
//                                 fontWeight: 'bold',
//                                 '&:hover': {
//                                     backgroundColor: value === 2 ? '#FF9630' : '#f5f5f5',


//                                 },
//                             }}
//                         />
//                     </Tabs>
//                 </Box>

//                 {/* Tab Content Section */}
//                 <Box sx={{ paddingTop: '20px' }}>
//                     {value === 0 && <BookingSummary />}
//                     {value === 1 && <TrackLocation/>}
//                     {value === 2 && <VehicalDoc />}
//                 </Box>
//             </div>
//         </div>
//     );
// };

// export default RideDetails;




import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { AiOutlineFile } from 'react-icons/ai';
import { MdLocationOn } from 'react-icons/md';
import { FaCar } from 'react-icons/fa';
import BookingSummary from './MBookingSummary';
import TrackLocation from './MTrackLocation';
import VehicalDoc from './MVehicleDOC';
import { FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const MRideDetails = () => {
    const [value, setValue] = useState(0);
    const navigate = useNavigate();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleBack = () => {
        navigate(0);
    };
    return (
        <>
            <div className="w-full bg-[#FF9630] text-white py-4 px-6 flex items-center">
                <button onClick={handleBack} className="mr-4 text-white hover:text-gray-200">
                    <FaArrowLeft className="text-lg" />
                </button>
                <h1 className="text-xl font-semibold">My Ride</h1>
            </div>
            <div className="flex justify-center items-center  bg-gray-100 w-full">
                <div className="w-full bg-white rounded-lg shadow-md p-6">
                    {/* Header */}

                    <div className="w-full flex justify-between space-x-2">

                        <button
                            className={`flex items-center justify-center rounded-lg transition-all duration-300 
                    ${value === 0 ? 'bg-[#FF9630] text-white' : 'bg-gray-200 text-gray-700'} 
                    w-36 sm:w-40 md:w-48 h-12 text-sm md:text-base font-bold`}
                            onClick={() => setValue(0)}
                        >
                            <AiOutlineFile className="mr-2 text-lg md:text-xl" />
                            Booking
                        </button>

                        {/* Track Location Tab */}
                        <button
                            className={`flex items-center justify-center rounded-lg transition-all duration-300 
                    ${value === 1 ? 'bg-[#FF9630] text-white' : 'bg-gray-200 text-gray-700'} 
                    w-36 sm:w-40 md:w-48 h-12 text-sm md:text-base font-bold`}
                            onClick={() => setValue(1)}
                        >
                            <MdLocationOn className="mr-2 text-lg md:text-xl" />
                            Location
                        </button>

                        {/* Vehicle DOC Tab */}
                        <button
                            className={`flex items-center justify-center rounded-lg transition-all duration-300 
                    ${value === 2 ? 'bg-[#FF9630] text-white' : 'bg-gray-200 text-gray-700'} 
                    w-36 sm:w-40 md:w-48 h-12 text-sm md:text-base font-bold`}
                            onClick={() => setValue(2)}
                        >
                            <FaCar className="mr-2 text-lg md:text-xl" />
                            Docs
                        </button>
                    </div>

                    {/* Tab Content Section */}
                    <div className="mt-6">
                        {value === 0 && <BookingSummary />}
                        {value === 1 && <TrackLocation />}
                        {value === 2 && <VehicalDoc />}
                    </div>
                </div>
            </div>
        </>
    );
};

export default MRideDetails;




